import React, { PropsWithChildren } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Container = styled.div`
  background-color: ${props => props.theme.palette.neutral.default.eight};
  border: 1px solid ${({ theme }) => theme.palette.neutral.default.five};
  border-radius: ${props => props.theme.borderRadius.M};
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${rem(4)};
  padding: ${rem(20)};
  overflow: hidden;
  min-height: ${rem(170)};
  max-width: ${rem(440)};
  width: 100%;

  ${mediaQueryUp.tablet} {
    width: ${rem(440)};
  }

  ${mediaQueryUp.desktop} {
    grid-template-columns: 1fr ${rem(80)};
    grid-template-rows: min-content min-content;
  }
`

type Props = PropsWithChildren<{}>

export default function LesaPurchaseSummaryContainer(props: Props) {
  const { children } = props

  return (
    <Container>
      {children}
    </Container>
  )
}
